/*
 * Resumo de parcelamento "em 12x / ou 3x" exibido abaixo do preco do produto.
 *
 * Extraido do script inline de snippets/product.liquid para poder ser testado
 * (tests/valor-dividido.test.js) e para existir num lugar so.
 *
 * Correcao principal em relacao ao script inline antigo: o parser nao removia o
 * separador de milhar, entao "R$ 2.997,00" era lido como 2.997 e o resumo
 * anunciava "em 12x de R$ 0,30" apos a troca de variante.
 *
 * As taxas sao as mesmas ja praticadas na loja e nao foram recalculadas aqui.
 */
(function (raiz, fabrica) {
  var api = fabrica();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  } else {
    raiz.NEValorDividido = api;
    if (typeof document !== 'undefined') api.iniciar();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  var TAXA_12X = 1.2047;

  var fmtCentavos = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  var fmtInteiro = new Intl.NumberFormat('pt-BR', {
    maximumFractionDigits: 0
  });

  /**
   * Converte o texto de preco renderizado na pagina para numero.
   * Trata separador de milhar, espaco nao-quebravel e simbolo de moeda.
   */
  function parsePreco(texto) {
    if (texto === null || texto === undefined) return NaN;

    var limpo = String(texto)
      .replace(/[\s ]/g, '')
      .replace(/[^\d.,-]/g, '');

    if (!limpo) return NaN;

    // remove o ponto usado como milhar (seguido de exatamente 3 digitos)
    limpo = limpo.replace(/\.(?=\d{3}(?:[.,]|$))/g, '').replace(',', '.');

    var valor = parseFloat(limpo);
    return isNaN(valor) ? NaN : valor;
  }

  // Espelha a aritmetica de inteiros do Liquid (`divided_by` trunca), a mesma
  // usada por assets/ne-parcelamento.js. Sem isso o resumo e o dropdown logo
  // abaixo dele discordam em 1 centavo no 12x.
  function centavosParcela(centavos, n, taxa) {
    return Math.round(Math.floor(centavos / n) * taxa);
  }

  function valor12x(preco) {
    return centavosParcela(Math.round(preco * 100), 12, TAXA_12X) / 100;
  }

  function valor3x(preco) {
    return centavosParcela(Math.round(preco * 100), 3, 1) / 100;
  }

  function html12x(preco) {
    return 'em <strong> 12x </strong> de <strong>R$ ' + fmtCentavos.format(valor12x(preco)) + '*</strong>';
  }

  function html3x(preco) {
    return 'ou <strong> 3x </strong> de <strong>R$ ' + fmtCentavos.format(valor3x(preco)) + '</strong> sem juros';
  }

  function atualizar(preco, el12x, el3x) {
    if (!isFinite(preco) || preco <= 0) return;
    if (el12x) el12x.innerHTML = html12x(preco);
    if (el3x) el3x.innerHTML = html3x(preco);
  }

  function iniciar() {
    function ligar() {
      var precos = document.querySelectorAll('[data-product-price]');
      // ids duplicados na pagina: ha um par por secao de produto renderizada
      var todos12x = document.querySelectorAll('[id="parcelamento-12x-produto"]');
      var todos3x = document.querySelectorAll('[id="parcelamento-3x-produto"]');

      Array.prototype.forEach.call(precos, function (elPreco, i) {
        var el12x = todos12x[i];
        var el3x = todos3x[i];
        if (!el12x && !el3x) return;
        if (elPreco.dataset && elPreco.dataset.neValorDividido === 'true') return;
        if (elPreco.dataset) elPreco.dataset.neValorDividido = 'true';

        function daPagina() {
          atualizar(parsePreco(elPreco.textContent || elPreco.innerText || ''), el12x, el3x);
        }

        new MutationObserver(daPagina).observe(elPreco, {
          characterData: true,
          childList: true,
          subtree: true
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ligar);
    } else {
      ligar();
    }

    // a quickview e as secoes do editor injetam esse markup depois do load
    document.addEventListener('shopify:section:load', ligar);
  }

  return {
    TAXA_12X: TAXA_12X,
    parsePreco: parsePreco,
    valor12x: valor12x,
    valor3x: valor3x,
    html12x: html12x,
    html3x: html3x,
    atualizar: atualizar,
    iniciar: iniciar
  };
});
